import { Controller } from '@hotwired/stimulus'

// Support [Collapse All] [Expand All] buttons for BS collapsed elements.
export default class BootstrapCollapseAllButtonController extends Controller {
    static targets = ['collapse', 'collapseAllButton', 'expandAllButton']

    connect() {
        this.updateButtonStates()

        // Listen to collapse events to update button states
        this.collapseTargets.forEach((collapse) => {
            collapse.addEventListener('shown.bs.collapse', this.updateButtonStates.bind(this))
            collapse.addEventListener('hidden.bs.collapse', this.updateButtonStates.bind(this))
        })
    }

    disconnect() {
        this.collapseTargets.forEach((collapse) => {
            collapse.removeEventListener('shown.bs.collapse', this.updateButtonStates.bind(this))
            collapse.removeEventListener('hidden.bs.collapse', this.updateButtonStates.bind(this))
        })
    }

    updateButtonStates() {
        const allCollapsed = this.collapseTargets.every(
            (collapse) => !collapse.classList.contains('show'),
        )
        this.collapseAllButtonTarget.classList.toggle('d-none', allCollapsed)
        this.expandAllButtonTarget.classList.toggle('d-none', !allCollapsed)
    }

    // Action method for collapsing all items
    collapseAll() {
        this.toggleAllCollapses('hide')
    }

    // Action method for expanding all items
    expandAll() {
        this.toggleAllCollapses('show')
    }

    // Helper method to toggle all collapses
    toggleAllCollapses(action) {
        this.collapseTargets.forEach((collapse) => {
            const bsCollapse = window.bootstrap.Collapse.getOrCreateInstance(collapse)
            bsCollapse[action]()
        })
    }
}
